import { useCallback, useEffect } from 'react'
export default function useClickOutside(
  ref: {
    current: HTMLElement | null | undefined
  },
  callback: () => void,
  capture: boolean = false,
) {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as any)) {
        callback()
      }
    },
    [ref, callback],
  )
  useEffect(() => {
    document.addEventListener('click', handleClick, capture)
    return () => {
      document.removeEventListener('click', handleClick, capture)
    }
  }, [handleClick, capture])
}
